import { Entry } from '../Entry'

export function Entry20260525() {
  return (
    <Entry title="2026 May 25 - v3.11.11">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RO/versions/25855/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
